import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-arrow-back-icon',
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_18151_36415)">
        <path
          d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_18151_36415">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowBackIconComponent {}
